import useDashboardContext from './context';
import DashboardProvider from './provider';

export { DashboardProvider };
export default useDashboardContext;
